import type { AccommodationReservationProviderInput } from "../../../../../__generated__/gql/graphql";
import type { BrowseAreaWithAvailability } from "../../_hooks/use-room-type-search";

import { SiteCard } from "./site-card";

/**
 * 並べ替えは行わない（満室拠点の除外は `selectVisibleAreas` 側で完了している）。
 * 先頭拠点のみ LCP 対策で `priority` を付与する。
 */
export function SiteList({
  areas,
  provider,
  facilitySlugs,
  evChargerAvailable,
  architectureTypes,
  largeOnly,
}: {
  areas: BrowseAreaWithAvailability[];
  provider: AccommodationReservationProviderInput;
  facilitySlugs: string[];
  evChargerAvailable: boolean;
  architectureTypes: string[];
  largeOnly: boolean;
}) {
  const sites = areas.flatMap((area) => area.sitesForReservation);
  return (
    <div className="flex flex-col gap-[40px]">
      {sites.map((site, index) => (
        <SiteCard
          key={site.id}
          site={site}
          priority={index === 0}
          provider={provider}
          facilitySlugs={facilitySlugs}
          evChargerAvailable={evChargerAvailable}
          architectureTypes={architectureTypes}
          largeOnly={largeOnly}
        />
      ))}
    </div>
  );
}
